
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1gp1v_17bd7_5",
  "control": "awsui_control_1gp1v_17bd7_6",
  "inline-label": "awsui_inline-label_1gp1v_17bd7_7",
  "inline-label-wrapper": "awsui_inline-label-wrapper_1gp1v_17bd7_8"
};
  